import { queueFont } from "../queueFont";

type WelcomeHeaderProps = {
  clinicName: string;
  subtitle?: string;
  /** overlay = centered hero on single-room view; inline = normal flow (multi-room grid) */
  layout?: "overlay" | "inline";
  compact?: boolean;
};

export function WelcomeHeader({
  clinicName,
  subtitle,
  layout = "overlay",
  compact = false,
}: WelcomeHeaderProps) {
  return (
    <div
      className={[
        queueFont,
        "mx-auto max-w-[min(1100px,92vw)] text-center leading-[1.15] text-slate-900 antialiased",
        layout === "overlay"
          ? "absolute left-[clamp(20px,3.5vmin,64px)] right-[clamp(20px,3.5vmin,64px)] top-[clamp(72px,9vmin,140px)]"
          : compact
            ? "relative shrink-0 px-3 pb-1 pt-2"
            : "relative shrink-0 px-[clamp(20px,3.5vmin,64px)] pb-[clamp(8px,1.5vmin,16px)] pt-[clamp(28px,4vmin,56px)]",
      ].join(" ")}
    >
      <div
        className={[
          queueFont,
          "font-extrabold tracking-wide text-[#0b3a66] [text-rendering:optimizeLegibility]",
          compact
            ? "mb-0.5 text-lg leading-tight"
            : "mb-[clamp(6px,1vmin,12px)] text-[clamp(34px,5.2vmin,64px)]",
        ].join(" ")}
      >
        Welcome to {clinicName || "Our Dental Clinic"}
      </div>
      <div
        className={[
          queueFont,
          "font-bold tracking-[0.02em] text-[#334155] [text-rendering:optimizeLegibility]",
          compact ? "text-xs leading-snug" : "text-[clamp(18px,2.8vmin,30px)]",
        ].join(" ")}
      >
        {subtitle ?? "Your smile is our priority!"}
      </div>
    </div>
  );
}
